import React, { useEffect, useState, useRef } from "react";
import Menu from "@mui/material/Menu";
import {
  Table,
  TableProps,
  Form,
  Input,
  InputNumber,
  Popconfirm,
  Tag,
  Space,
  Button as Buttons,
  notification,
  Select,
  Typography as Typographys,
  Modal,
} from "antd";
import {
  DeleteOutlined,
  EditOutlined,
  InfoCircleOutlined,
  FileDoneOutlined,
  FileProtectOutlined,
  SearchOutlined,
  UndoOutlined,
  CheckCircleOutlined,
  StopOutlined,
  CheckOutlined,
} from "@ant-design/icons";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import Box from "@mui/material/Box";
import { styled } from "@mui/material/styles";
import AffiliateIndividualMemberController from "./Controller/affiliate_individual_membership_controller.ts";
import CorporateMemberController from "./Controller/corporate_membership_controller.ts";
import IndividualMemberController from "./Controller/individual_membership_controller.ts";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Checkbox from "@mui/material/Checkbox";
import dayjs from "dayjs";
import { createStyles } from "antd-style";
import CustomSeparator from "../../layouts/AdminLayout/Header/Breadcrumbs.js";
import { Typography } from "@mui/material";
import type { InputRef, TableColumnType } from "antd";
import type { FilterDropdownProps } from "antd/es/table/interface";
import Highlighter from "react-highlight-words";
import { PDFDownloadLink, BlobProvider } from "@react-pdf/renderer";
import MyDocument from "./pdf/membership-invoice.tsx";
import { Link } from "react-router-dom";
import IndividualCert from "./pdf/individual-membership-cert.tsx";
import { pdf } from "@react-pdf/renderer";
import SignatureController from "./Controller/signature_controller.ts";
import AffiliateIndividualMembershipListExcel from "./excel/affiliate_individual_membership_list_excel.jsx";
import MembershipCertController from "./Controller/ECert_controller.ts";
import ECert from "./pdf/membership-cert.tsx";
import WorkspacePremiumIcon from "@mui/icons-material/WorkspacePremium";

//imports by  delon on  2025-07-30
import NotificationsIcon from '@mui/icons-material/Notifications';
import axios from "axios";
import InfinityEncryptor from '../../i-plugins/InfinityEncryptor.tsx';

const useStyle = createStyles(({ css }) => {
  return {
    customTable: css`
      .ant-table {
        .ant-table-container {
          .ant-table-body,
          .ant-table-content {
            scrollbar-width: thin;
            scrollbar-color: #eaeaea transparent;
            scrollbar-gutter: stable;
          }
        }
      }
    `,
  };
});

type NotificationType = "success" | "info" | "warning" | "error";
const { Text } = Typographys;
const { TextArea } = Input;

type TableRowSelection<T extends object = object> =
  TableProps<T>["rowSelection"];

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
}));

interface DataType {
  membership_registrationID: string;
  membership_status: number;
  key: number;
  individual_name: string;
  individual_nric: number;
  individual_dob: dayjs.Dayjs;
  individual_correspondence_address: string;
  individual_registered_address: string;
  individual_place_of_employment: string;
  individual_office_address: string;
  individual_office_tel_no: string;
  individual_hp_no: string;
  individual_email: string;
  individual_designation: string;
  individual_nature_of_work: string;
  individual_no_of_years_with_present_employer: number;
  individual_previous_employment_period_1: number;
  individual_previous_employment_designation_1: string;
  individual_previous_employment_period_2: number;
  individual_previous_employment_designation_2: string;
  individual_academic_qualification: string;
  individual_tertiary_professional: string;
  application_status: number;
  operation: number;
  committee_typeID: string;
  memberID: string;
  paymentID: string;
  payment_status: number;
  committee_type_label: string;
  payment_remark: string;
  payment_type: string;
  mc_max_term: string;
  member_type_label: string;
  total_amount: number;
  amount_paid: number;
  datetime_paid: string;
}

type DataIndex = keyof DataType;

interface EditableCellProps extends React.HTMLAttributes<HTMLElement> {
  editing: boolean;
  dataIndex: string;
  title: any;
  inputType:
    | "number"
    | "text"
    | "date"
    | "select"
    | "select_payment"
    | "payment_remark"
    | "individual_previous_employment_period_1"
    | "individual_previous_employment_designation_1"
    | "individual_previous_employment_period_2"
    | "individual_previous_employment_designation_2"
    | "individual_academic_qualification"
    | "individual_nationality"
    | "individual_nric"
    | "committee_typeID";
  record: DataType;
  index: number;
  options: any;
}

const EditableCell: React.FC<React.PropsWithChildren<EditableCellProps>> = ({
  editing,
  dataIndex,
  title,
  inputType,
  record,
  index,
  children,
  options,
  ...restProps
}) => {
  // Determine the input node based on inputType
  let inputNode: any;
  let required_field = true;
  if (inputType === "date") {
    required_field = false;
    inputNode = <Input type="date" />;
  } else if (inputType === "number") {
    inputNode = <InputNumber />;
  } else if (inputType === "committee_typeID") {
    let disabled: any;
    required_field = false;
    if (record.memberID == null) {
      disabled = true;
    }
    inputNode = (
      <Select
        disabled={disabled}
        value={record.committee_typeID ? "null" : record.committee_typeID}
      >
        {options.map((option) => (
          <Select.Option key={option.value} value={option.value}>
            {option.label}
          </Select.Option>
        ))}
      </Select>
    );
  } else if (inputType === "select_payment") {
    let disabled: any;
    required_field = false;
    if (record.payment_status == null) {
      disabled = true;
    }
    inputNode = (
      <Select
        style={{ marginBottom: 2 }}
        disabled={disabled}
        value={record.payment_status}
      >
        {options.map((option) => (
          <Select.Option key={option.value} value={option.value}>
            {option.label}
          </Select.Option>
        ))}
      </Select>
    );
  } else if (inputType === "payment_remark") {
    let disabled: any;
    required_field = false;
    if (record.payment_status == null) {
      disabled = true;
    }

    inputNode = (
      <TextArea disabled={disabled} autoSize={{ minRows: 2, maxRows: 10 }} />
    );
  } else if (inputType === "individual_previous_employment_period_1") {
    required_field = false;
    inputNode = (
      <InputNumber addonBefore="Year(s)" min={1} max={50} changeOnWheel />
    );
  } else if (inputType === "individual_previous_employment_period_2") {
    required_field = false;
    inputNode = (
      <InputNumber addonBefore="Year(s)" min={1} max={50} changeOnWheel />
    );
  } else if (inputType === "individual_previous_employment_designation_1") {
    required_field = false;
    inputNode = (
      <InputNumber addonBefore="Year(s)" min={1} max={50} changeOnWheel />
    );
  } else if (inputType === "individual_previous_employment_designation_2") {
    required_field = false;
    inputNode = (
      <InputNumber addonBefore="Year(s)" min={1} max={50} changeOnWheel />
    );
  } else if (inputType === "individual_academic_qualification") {
    required_field = false;
    inputNode = (
      <Select>
        {options.map((option) => (
          <Select.Option key={option.value} value={option.value}>
            {option.label}
          </Select.Option>
        ))}
      </Select>
    );
  } else {
    required_field = false;
    inputNode = <TextArea autoSize={{ minRows: 2, maxRows: 10 }} />;
  }

  return (
    <td {...restProps}>
      {editing ? (
        <Form.Item
          name={dataIndex}
          style={{ margin: 0 }}
          rules={[
            {
              required: required_field,
              message: `Please Input ${title}!`,
            },
          ]}
        >
          {inputNode}
        </Form.Item>
      ) : (
        children
      )}
    </td>
  );
};

const CheckboxList = ({ baseColumns, checkedColumns, onChange }) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleToggle = (value: Number) => () => {
    const currentIndex = checkedColumns.indexOf(value);
    const newChecked = [...checkedColumns];

    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }

    onChange(newChecked); // Call the parent onChange handler
  };

  return (
    <>
      <Button
        id="demo-positioned-button"
        aria-controls={open ? "demo-positioned-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        onClick={handleClick}
        variant="contained"
        sx={{ mb: 3 }}
        style={{ backgroundColor: "#d33333" }}
      >
        Columns
      </Button>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        PaperProps={{
          style: {
            // maxHeight: 400,
            width: "20ch",
          },
        }}
      >
        <List
          sx={{ width: "100%", maxWidth: 360, bgcolor: "background.paper" }}
        >
          {baseColumns.map((value: any) => {
            // Check if the value.dataIndex is in the checkedColumns array
            const isChecked = checkedColumns.includes(value.dataIndex);

            const labelId = `checkbox-list-label-${value.dataIndex}`;
            return (
              <ListItem key={value.dataIndex} disablePadding>
                <ListItemButton
                  role={undefined}
                  onClick={handleToggle(value.dataIndex)}
                  dense
                >
                  <ListItemIcon>
                    <Checkbox
                      edge="start"
                      checked={isChecked} // Use isChecked to determine if checked
                      tabIndex={-1}
                      disableRipple
                      inputProps={{ "aria-labelledby": labelId }}
                    />
                  </ListItemIcon>
                  <ListItemText id={labelId} primary={value.title} />
                </ListItemButton>
              </ListItem>
            );
          })}
        </List>
      </Menu>
    </>
  );
};

const formatDate = (dateString) => {
  const date = new Date(dateString); // Convert to Date object
  return date.toLocaleString("en-US", {
    weekday: "long", // Example: Friday
    year: "numeric", // Example: 2024
    month: "long", // Example: November
    day: "numeric", // Example: 29
    hour: "numeric", // Example: 9
    minute: "numeric", // Example: 30
  });
};

function App() {
  //Get Pending notification count edited by delon on 2025-07-30
  //states
  const [pendingRegistrationsCount, SetPendingRegistrationsCount] = useState({"corporate": 0, "individual": 0, "affiliate-corporate": 0, "affiliate-individual": 0, "associate": 0, "honorary-member": 0});
  useEffect(() => {
    const encryptor = new InfinityEncryptor('22499', 'MYDIH');
    const formData  = new FormData();
    formData.append("s3cr3t", encryptor.Encrypt('ppkm_14082024_mobile'));
    formData.append("fetchPendingRegistrationsCount", encryptor.Encrypt("true"));

    axios.post("https://www.ppkm.org.my/mobile_backend/scripts/registrationControl.php", formData, { withCredentials: false }).then((res: any) => {
      const decrypted = encryptor.Decrypt(res.data);
      let resObj = {} as any;
      try {
        resObj = JSON.parse(decrypted) as any;
      } catch {
        resObj = decrypted as any;
      }
      console.log(decrypted);
      SetPendingRegistrationsCount(resObj);
    }).catch((err: string) => {
      console.log('fetchPendingRegistrationsCountErr: ' + err);
    });
  }, []);

  const [api, contextHolder] = notification.useNotification();

  const openNotificationWithIcon = (
    type: NotificationType,
    desc: String,
    message: String
  ) => {
    api[type]({
      message: message,
      description: desc,
    });
  };

  const [rows, setRows] = useState<any[]>([]);
  const [data, setData] = useState<DataType[]>(rows);
  const [shouldRefetchData, setShouldRefetchData] = useState(false);

  //test
  // useEffect(() => {
  //     console.log('affiliate_individual_membership_applicationsTest: ' + JSON.stringify(data));
  // }, [data]);

  useEffect(() => {
    AffiliateIndividualMemberController.getData().then((response) => {
      /** edited by delon on 2025-07-31 */
      const SortRegistrationsByDateDesc = (registrations: any) => {
        // console.log('checkRegistration: ' + JSON.stringify(registrations));
        //date sort
        const sorted = [] as any;
        registrations.map((registration: any) => {
          let isSorted = false;
          if(registration['datetime_created'] != undefined)  {
            sorted.map((sort: any, i: number) => {
              if(
                !isSorted
                && (
                  (registration['payment_status'] == null && sorted['payment_status'] == 1)
                  || (registration['payment_status'] == 0 && sorted['payment_status'] != 0)
                  || (registration['payment_status'] == null && sorted['payment_status'] == null && registration['datetime_created'] >= sort['datetime_created'])
                  || (registration['payment_status'] == 0 && sorted['payment_status'] == 0 && registration['datetime_created'] >= sort['datetime_created'])
                  || (registration['payment_status'] == 1 && sorted['payment_status'] == 1 && registration['datetime_created'] >= sort['datetime_created'])
                )
              ) {
                sorted.splice(i, 0, registration);
                isSorted = true;
              }
            });
            if(!isSorted) {
              sorted.push(registration);
            }
          }
        });

        return sorted;
      }

      if (Array.isArray(response)) {
        const dynamicRows = SortRegistrationsByDateDesc(response).map((item, index) => {
          console.log(item);
          return {
            key: index,
            membership_registrationID: item.membership_registrationID,
            member_type_label: item.member_type_label,
            membership_status: item.membership_status,
            individual_salutation: item.individual_salutation,
            individual_name: item.individual_name,
            individual_nric: item.individual_nric,
            individual_dob: item.individual_dob,
            individual_pob: item.individual_pob,
            individual_race: item.individual_race,
            individual_sex: item.individual_sex,
            individual_nationality: item.individual_nationality,
            individual_marital_status: item.individual_marital_status,
            individual_correspondence_address:
              item.individual_correspondence_address,
            individual_registered_address: item.individual_registered_address,
            individual_place_of_employment: item.individual_place_of_employment,
            individual_office_address: item.individual_office_address,
            individual_office_tel_no: item.individual_office_tel_no,
            individual_hp_no: item.individual_hp_no,
            individual_email: item.individual_email,
            individual_designation: item.individual_designation,
            individual_nature_of_work: item.individual_nature_of_work,
            individual_no_of_years_with_present_employer:
              item.individual_no_of_years_with_present_employer,
            individual_previous_employment_period_1:
              item.individual_previous_employment_period_1,
            individual_previous_employment_designation_1:
              item.individual_previous_employment_designation_1,
            individual_previous_employment_period_2:
              item.individual_previous_employment_period_2,
            individual_previous_employment_designation_2:
              item.individual_previous_employment_designation_2,
            individual_academic_qualification:
              item.individual_academic_qualification,
            individual_tertiary_professional:
              item.individual_tertiary_professional,
            application_status: item.application_status,
            committee_typeID: item.committee_typeID,
            committee_type_label: item.committee_type_label,
            memberID: item.memberID,
            paymentID: item.paymentID,
            payment_status: item.payment_status,
            payment_remark: item.payment_remark,
            mc_max_term: item.mc_max_term,
            payment_type: item.payment_type,
            total_amount: item.total_amount
              ? item.total_amount.toLocaleString("en-US", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })
              : item.total_amount,
            amount_paid: item.amount_paid
              ? item.amount_paid.toLocaleString("en-US", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })
              : item.amount_paid,
            datetime_paid: item.datetime_paid,
          };
        });

        setRows(Array.from(dynamicRows));
      } else {
      }
    });
  }, [shouldRefetchData]);

  // Update data whenever rows changes
  useEffect(() => {
    setData(rows);
  }, [rows]);

  // **************************** MODAL TO INPUT MEMBER ID *****************************************************
  const [isModalMemberIDOpen, setIsModalMemberIDOpen] = useState(false);
  const [membership_registrationID, setMembershipRegistrationID] = useState("");
  const [membershipNumber, setMembershipNumber] = useState("");

  const showModalMemberID = (membership_registrationID) => {
    setIsModalMemberIDOpen(true);
    setMembershipRegistrationID(membership_registrationID);
  };

  // *************************************************************************************************************
  // **************************** MODAL TO INPUT PAYMENT *****************************************************
  const [isModalPaymentOpen, setIsModalPaymentOpen] = useState(false);
  const [memberID, setMemberID] = useState("");
  const [paymentAmount, setPaymentAmount] = useState("");
  const [paymentReference, setPaymentReference] = useState("");

  const showModalPayment = (membership_registrationID, memberID) => {
    setIsModalPaymentOpen(true);
    setMembershipRegistrationID(membership_registrationID);
    setMemberID(memberID);
  };

  // *************************************************************************************************************

  const [form] = Form.useForm();
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
  const [editingKey, setEditingKey] = useState("");

  const userID = localStorage.getItem("userID");

  const isEditing = (record: DataType) => {
    return String(record.membership_registrationID) === String(editingKey);
  };
  // Number(record.membership_registrationID) === Number(editingKey);
  const edit = (
    record: Partial<DataType> & { membership_registrationID: string }
  ) => {
    form.setFieldsValue({ name: "", age: "", address: "", ...record });
    setEditingKey(record.membership_registrationID);
  };

  const cancel = () => {
    setEditingKey("");
  };

  type ApiResponse = {
    data: any[];
    status: string;
  };

  const delete_member = (rowId: any, memberID: any, paymentID: any, userID) => {
    const payload = new FormData();
    payload.append("ID", rowId);
    payload.append("memberID", memberID);
    payload.append("userID", userID);
    payload.append("paymentID", paymentID);

    // console.log(rowId);
    // console.log(memberID);
    // console.log(paymentID);
    IndividualMemberController.deleteMember(payload).then((response) => {
      if (response?.status === "success") {
        openNotificationWithIcon(
          "success",
          "Your data has been deleted successfully!",
          "Success"
        );

        setShouldRefetchData((prev) => !prev); // Toggle to re-trigger useEffect
      }
    });
  };

  const deactivateMember = (rowId: any, userID) => {
    const payload = new FormData();
    payload.append("memberID", rowId);
    payload.append("userID", userID);

    CorporateMemberController.deactivateMembership(payload).then((response) => {
      if (response?.status === "success") {
        openNotificationWithIcon(
          "success",
          "Membership has been deactivated successfully!",
          "Success"
        );

        setShouldRefetchData((prev) => !prev); // Toggle to re-trigger useEffect
      }
    });
  };

  const reactivateMember = (rowId: any, userID) => {
    const payload = new FormData();
    payload.append("memberID", rowId);
    payload.append("userID", userID);

    CorporateMemberController.reactivateMembership(payload).then((response) => {
      if (response?.status === "success") {
        openNotificationWithIcon(
          "success",
          "Membership has been reactivated successfully!",
          "Success"
        );

        setShouldRefetchData((prev) => !prev); // Toggle to re-trigger useEffect
      }
    });
  };

  const delete_record = (rowId: any, userID) => {
    const payload = new FormData();
    payload.append("ID", rowId);
    payload.append("userID", userID);

    AffiliateIndividualMemberController.deleteRow(payload).then((response) => {
      if (response?.status === "success") {
        openNotificationWithIcon(
          "success",
          "Your data has been deleted successfully!",
          "Success"
        );
      }
    });
  };

  const save = async (key: React.Key, userID) => {
    try {
      const row = (await form.validateFields()) as DataType;

      const newData = [...data];
      const index = newData.findIndex(
        (item) => key === item.membership_registrationID
      );
      const membership_registrationID =
        newData[index].membership_registrationID;
      const memberID = newData[index].memberID;
      const status = newData[index].application_status;

      const paymentID = newData[index].paymentID;
      if (index > -1) {
        // set rows here

        const payload = {
          ID: membership_registrationID,
          membership_status: status,
          memberID: memberID,
          paymentID: paymentID,
          data: row,
          userID: userID,
        };

        AffiliateIndividualMemberController.saveRow(payload).then(
          (response) => {
            if (response?.status === "success") {
              openNotificationWithIcon(
                "success",
                "Your data has been saved successfully!",
                "Success"
              );

              setShouldRefetchData((prev) => !prev); // Toggle to re-trigger useEffect
            }
          }
        );

        setEditingKey("");
      } else {
        // newData.push(row);
        setData(newData);
        setEditingKey("");
      }
    } catch (errInfo) {
      console.log("Validate Failed:", errInfo);
    }
  };

  const generatePdfBlob = async (dataItem: any) => {
    console.log('checkDataItem: ' + JSON.stringify(dataItem));
    const response = await SignatureController.getSignatures(); // Fetch latest signatures
    const presidentData = response.find(
      (data) => Number(data.designation) === 0
    );
    const secretariatData = response.find(
      (data) => Number(data.designation) === 1
    );

    const blob = await pdf(
      <IndividualCert
        data={dataItem}
        presidentData={presidentData}
        secretariatData={secretariatData}
      />
    ).toBlob();

    return blob;
  };

  const blobToBase64 = (blob: Blob) => {
    return new Promise<string>((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => {
        const result = reader.result;
        if (typeof result === "string") {
          resolve(result.split(",")[1]); // Extract Base64 string
        } else {
          reject(new Error("Failed to read file"));
        }
      };
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
  };

  const handleApprove = async (userID) => {
    const membershipRegistrationID = membership_registrationID;
    console.log(paymentAmount);
    console.log(paymentReference);

    try {
      const newData = [...data];
      const index = newData.findIndex(
        (item) =>
          String(membershipRegistrationID) ===
          String(item.membership_registrationID)
      );

      const pdfBlob = await generatePdfBlob(newData[index]);
      const pdfBase64 = await blobToBase64(pdfBlob);

      if (index > -1) {
        const payload = new FormData();
        payload.append("membership_registrationID", membershipRegistrationID);
        payload.append("memberID", membershipNumber);
        payload.append("userID", userID);

        if (typeof pdfBase64 === "string") {
          payload.append("pdfCertificateBase64", pdfBase64);
        } else {
          console.error("pdfBase64 is not a string");
        }

        payload.append("paid_amount", paymentAmount);
        payload.append("payment_reference", paymentReference);

        AffiliateIndividualMemberController.approveMembership(payload).then(
          (response) => {
            //edited by delon on 2025-07-30
            if(!JSON.stringify(response).includes('_false')) {
              form.resetFields(); // Clear input after submitting

              setIsModalMemberIDOpen(false); // Close modal after submit

              openNotificationWithIcon(
                "success",
                "Application has been approved successfully!",
                "Success"
              );

              setShouldRefetchData((prev) => !prev); // Toggle to re-trigger useEffect
            }  else {
              if(JSON.stringify(response).includes('registerMemberErr')) {
                openNotificationWithIcon("error", "Fail to create new membership record, please check if the membership no is already assigned to an existing member.", "Error");
              } else if(JSON.stringify(response).includes('createPaymentAndGenerateMembershipContractErr')) {
                openNotificationWithIcon("error", "Fail to create payment and membership contract record, please contact support.", "Error");
              }
            }

            // console.log(response);
            // if (response?.status === "success") {
            //   form.resetFields(); // Clear input after submitting

            //   setIsModalMemberIDOpen(false); // Close modal after submit

            //   openNotificationWithIcon(
            //     "success",
            //     "Application has been approved successfully!",
            //     "Success"
            //   );

            //   setShouldRefetchData((prev) => !prev); // Toggle to re-trigger useEffect
            // } ---deprecated
          }
        );
      }
    } catch (errInfo) {}
  };

  const handleActivateMembership = async (userID) => {
    const payload = new FormData();
    payload.append("memberID", memberID);
    payload.append("userID", userID);
    payload.append("membership_registrationID", membership_registrationID);
    payload.append("paid_amount", paymentAmount);
    payload.append("payment_reference", paymentReference);

    AffiliateIndividualMemberController.renewMembership(payload).then(
      (response) => {
        console.log(response);

        if (response?.status === "success") {
          setShouldRefetchData((prev) => !prev); // Toggle to re-trigger useEffect
          setIsModalPaymentOpen(false);
          form.resetFields(); // Clear input after submitting
          openNotificationWithIcon(
            "success",
            "Membership contract renewal has been created successfully!",
            "Success"
          );
        }
      }
    );
  };

  const handleUndoApprove = async (key: React.Key, userID) => {
    try {
      const newData = [...data];
      const index = newData.findIndex(
        (item) => key === item.membership_registrationID
      );
      const membership_registrationID =
        newData[index].membership_registrationID;
      const paymentID = newData[index].paymentID;
      const memberID = newData[index].memberID;

      if (index > -1) {
        const payload = {
          ID: membership_registrationID,
          paymentID: paymentID,
          memberID: memberID,
          userID: userID,
        };

        AffiliateIndividualMemberController.removeMembership(payload).then(
          (response) => {
            if (response?.status === "success") {
              openNotificationWithIcon(
                "success",
                "Member has been removed successfully!",
                "Success"
              );

              setShouldRefetchData((prev) => !prev); // Toggle to re-trigger useEffect
            }
          }
        );
      }
    } catch (errInfo) {}
  };

  // **************************** SEARCH FILTER ANTD TABLE *****************************************************
  const [searchText, setSearchText] = useState("");
  const [searchedColumn, setSearchedColumn] = useState("");
  const searchInput = useRef<InputRef>(null);

  const openPdfPreview = (url) => {
    // Open the PDF in a new tab
    const newWindow = window.open(url, "_blank");
    if (!newWindow) {
      alert("Please allow popups for this website to preview the PDF.");
    }
  };

  const handleSearch = (
    selectedKeys: string[],
    confirm: FilterDropdownProps["confirm"],
    dataIndex: DataIndex
  ) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };

  const handleReset = (clearFilters: () => void) => {
    clearFilters();
    setSearchText("");
  };

  const getColumnSearchProps = (
    dataIndex: DataIndex
  ): TableColumnType<DataType> => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
      close,
    }) => (
      <div style={{ padding: 8 }} onKeyDown={(e) => e.stopPropagation()}>
        <Input
          ref={searchInput}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() =>
            handleSearch(selectedKeys as string[], confirm, dataIndex)
          }
          style={{ marginBottom: 8, display: "block" }}
        />
        <Space>
          <Buttons
            type="primary"
            onClick={() =>
              handleSearch(selectedKeys as string[], confirm, dataIndex)
            }
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            Search
          </Buttons>
          <Buttons
            onClick={() => clearFilters && handleReset(clearFilters)}
            size="small"
            style={{ width: 90 }}
          >
            Reset
          </Buttons>
          <Buttons
            type="link"
            size="small"
            onClick={() => {
              confirm({ closeDropdown: false });
              setSearchText((selectedKeys as string[])[0]);
              setSearchedColumn(dataIndex);
            }}
          >
            Filter
          </Buttons>
          <Buttons
            type="link"
            size="small"
            onClick={() => {
              close();
            }}
          >
            close
          </Buttons>
        </Space>
      </div>
    ),
    filterIcon: (filtered: boolean) => (
      <SearchOutlined style={{ color: filtered ? "#1677ff" : undefined }} />
    ),
    onFilter: (value, record) =>
      String(record?.[dataIndex] ?? '')
        .toString()
        .toLowerCase()
        .includes((value as string).toLowerCase()),
    onFilterDropdownOpenChange: (open) => {
      if (open) {
        setTimeout(() => searchInput.current?.select(), 100);
      }
    },
    render: (text) =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ""}
        />
      ) : (
        text
      ),
  });
  // ************************************************************************************************************

  const handleQueryString = (path: string, state: Record<string, string>) => {
    const queryString = new URLSearchParams(state).toString();
    return `${path}?${queryString}`;
  };

  const handleGenerateCert = async (memberID: string) => {
    try {
      const payload = new FormData();
      payload.append("memberID", memberID);

      const data = await MembershipCertController.getMembershipCertInfo(
        payload
      );
      const signatures = await SignatureController.getSignatures();

      const presidentData = signatures.find(
        (sig) => Number(sig.designation) === 0
      );
      const secretariatData = signatures.find(
        (sig) => Number(sig.designation) === 1
      );

      if (!presidentData?.signature_url || !secretariatData?.signature_url) {
        alert(
          "Cannot generate certificate.\nMissing president or secretary signature."
        );
        return;
      }

      const blob = await pdf(
        <ECert
          data={data}
          presidentData={presidentData}
          secretariatData={secretariatData}
        />
      ).toBlob();

      const url = URL.createObjectURL(blob);
      window.open(url, "_blank");

      // Optional: If you want to revoke the URL after opening it
      // setTimeout(() => URL.revokeObjectURL(url), 5000);
    } catch (err) {
      console.error("Error generating PDF:", err);
      alert("Failed to generate e-certificate.\nPlease try again.");
    }
  };

  const baseColumns = [
    {
      title: "Operation",
      dataIndex: "operation",
      width: 180,
      render: (_: any, record: DataType) => {
        const editable = isEditing(record);

        const path = "/admin/individual_info";
        const state = {
          membership_registrationID: record.membership_registrationID,
        };
        const fullPath = handleQueryString(path, state);

        return (
          <>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                width: "90%",
              }}
            >
              <Buttons
                type="default"
                style={{ marginBottom: "10px" }}
                icon={<InfoCircleOutlined />}
              >
                <Link
                  to={fullPath}
                  rel="noopener noreferrer"
                  style={{ textDecoration: "none", color: "inherit" }}
                >
                  Info
                </Link>
              </Buttons>
              {/* <Buttons
                type="default"
                style={{ marginBottom: "10px" }}
                icon={<FileProtectOutlined />}
                onClick={generatePdfBlob}
              >
                E-Cert
              </Buttons> */}

              {editable ? (
                <>
                  <Buttons
                    onClick={() =>
                      save(record.membership_registrationID, userID)
                    }
                    color="default"
                    variant="solid"
                    style={{ marginBottom: "10px" }}
                  >
                    Save
                  </Buttons>
                  <Buttons color="default" variant="outlined">
                    <Popconfirm title="Sure to cancel?" onConfirm={cancel}>
                      Cancel
                    </Popconfirm>
                  </Buttons>
                </>
              ) : (
                <>
                  <Buttons
                    color="default"
                    variant="solid"
                    icon={<EditOutlined />}
                    disabled={editingKey !== ""}
                    onClick={() => edit(record)}
                    style={{ marginBottom: "10px" }}
                  >
                    Edit
                  </Buttons>

                  {Number(record.application_status) === 0 && (
                    <Popconfirm
                      title="Sure to approve?"
                      onConfirm={() =>
                        showModalMemberID(record.membership_registrationID)
                      }
                    >
                      <Buttons
                        color="default"
                        variant="outlined"
                        disabled={editingKey !== ""}
                        style={{ marginBottom: "10px" }}
                      >
                        <FileDoneOutlined /> Approve
                      </Buttons>
                    </Popconfirm>
                  )}

                  {Number(record.payment_status) === 0 &&
                    Number(record.application_status) === 1 && (
                      <>
                        <Buttons
                          color="default"
                          variant="outlined"
                          disabled={editingKey !== ""}
                          style={{ marginBottom: "10px" }}
                        >
                          <UndoOutlined />
                          <Popconfirm
                            title="Sure to undo approval?"
                            onConfirm={() =>
                              handleUndoApprove(
                                record.membership_registrationID,
                                userID
                              )
                            }
                          >
                            Undo Approve
                          </Popconfirm>
                        </Buttons>
                      </>
                    )}

                  {Number(record.application_status) === 0 && (
                    <Buttons
                      type="primary"
                      danger
                      icon={<DeleteOutlined />}
                      disabled={editingKey !== ""}
                    >
                      <Popconfirm
                        title="Sure to delete?"
                        onConfirm={() =>
                          delete_record(
                            record.membership_registrationID,
                            userID
                          )
                        }
                      >
                        Delete
                      </Popconfirm>
                    </Buttons>
                  )}

                  {Number(record.application_status) === 1 && (
                    <>
                      <Buttons
                        type="default"
                        color="primary"
                        style={{ marginBottom: "10px" }}
                        icon={<WorkspacePremiumIcon />}
                        onClick={() => handleGenerateCert(record.memberID)}
                      >
                        E-Certificate
                      </Buttons>
                      <Buttons
                        type="primary"
                        style={{ marginBottom: "10px" }}
                        danger
                        icon={<DeleteOutlined />}
                        disabled={editingKey !== ""}
                      >
                        <Popconfirm
                          title="Sure to delete?"
                          onConfirm={() =>
                            delete_member(
                              record.membership_registrationID,
                              record.memberID,
                              record.paymentID,
                              userID
                            )
                          }
                        >
                          Delete Member
                        </Popconfirm>
                      </Buttons>
                    </>
                  )}

                  {record.mc_max_term &&
                    new Date(record.mc_max_term) < new Date() &&
                    Number(record.payment_status) === 1 && (
                      <Buttons
                        color="default"
                        variant="outlined"
                        disabled={editingKey !== ""}
                        style={{
                          marginBottom: "10px",
                          backgroundColor: "#4CAF50", // Custom background color
                          color: "#FFFFFF", // Custom text color
                          borderColor: "#4CAF50", // Custom border color
                        }}
                      >
                        <Popconfirm
                          title="Sure to activate membership?"
                          onConfirm={() =>
                            showModalPayment(
                              record.membership_registrationID,
                              record.memberID
                            )
                          }
                        >
                          <CheckCircleOutlined /> Renew
                        </Popconfirm>
                      </Buttons>
                    )}

                  {record.memberID &&
                    Number(record.membership_status) === 1 && (
                      <Buttons
                        type="primary"
                        style={{ marginBottom: "10px" }}
                        danger
                        icon={<StopOutlined />}
                        disabled={editingKey !== ""}
                      >
                        <Popconfirm
                          title="Sure to suspend membership?"
                          onConfirm={() =>
                            deactivateMember(record.memberID, userID)
                          }
                        >
                          Suspend
                        </Popconfirm>
                      </Buttons>
                    )}

                  {record.memberID &&
                    Number(record.membership_status) === 0 && (
                      <Buttons
                        type="primary"
                        style={{
                          marginBottom: "10px",
                          backgroundColor: "#4CAF50", // Custom background color
                          color: "#FFFFFF", // Custom text color
                          borderColor: "#4CAF50", // Custom border color
                        }}
                        danger
                        icon={<CheckOutlined />}
                        disabled={editingKey !== ""}
                      >
                        <Popconfirm
                          title="Sure to activate membership?"
                          onConfirm={() =>
                            reactivateMember(record.memberID, userID)
                          }
                        >
                          Unsuspend
                        </Popconfirm>
                      </Buttons>
                    )}
                </>
              )}
            </div>
          </>
        );
      },
    },
    {
      title: "Registration ID",
      dataIndex: "membership_registrationID",
      key: "membership_registrationID",
    },
    {
      title: "Membership No.",
      dataIndex: "memberID",
      key: "memberID",
      editable: true,
      ...getColumnSearchProps("memberID"), //IMPLEMENT SEARCH FILTER
    },
    {
      title: "Member Type",
      dataIndex: "member_type_label",
      key: "member_type_label",
      render: (status: any, record: DataType) => {
        if (record.member_type_label) {
          return <Tag color="green">{record.member_type_label}</Tag>;
        } else {
          return <Tag color="red">{"N/A"}</Tag>;
        }
      },
      // filters: memberTypeFilter,
      // onFilter: (value, record) => record.member_typeID === value,
    },
    {
      title: "Status",
      dataIndex: "application_status",
      key: "application_status",
      width: 200,
      render: (status: any, record: DataType) => {
        if (status === 1) {
          return (
            <>
              <div style={{ display: "flex", flexDirection: "column" }}>
                <Text>
                  Application: <Tag color="blue">Approved</Tag>
                </Text>
                <Text>
                  Membership:
                  {record.membership_status === 1 ? (
                    <Tag color="green">Active</Tag>
                  ) : (
                    <Tag color="red">Inactive</Tag>
                  )}
                </Text>
              </div>
            </>
          );
        } else {
          return (
            <>
              <Text>
                Application: <Tag color="orange">Pending</Tag>{" "}
              </Text>{" "}
              <Text>
                Membership: <Tag color="red">Inactive</Tag>{" "}
              </Text>
            </>
          );
        }
      },
      filters: [
        { text: "Approved", value: 1 },
        { text: "Pending", value: 0 },
      ],
      onFilter: (value, record) => record.application_status === value,
    },
    {
      title: "Payment",
      dataIndex: "payment_status",
      key: "payment_status",
      width: 200,
      render: (payment_status: any, record: DataType) => {
        let payment_issued = record.paymentID;
        let max_term_color = "";

        if (new Date(record.mc_max_term) < new Date()) {
          max_term_color = "red";
        } else {
          max_term_color = "green";
        }

        if (new Date(record.mc_max_term) < new Date()) {
          max_term_color = "red";
        } else {
          max_term_color = "green";
        }

        if (payment_issued && Number(payment_status) === 1) {
          return (
            <Space direction="vertical" size="small">
              <Text>
                Type: <Tag color="green">{record.payment_type}</Tag>
              </Text>
              <Text>
                Max Term: <Tag color={max_term_color}>{record.mc_max_term}</Tag>
              </Text>
              <Text>
                Status: <Tag color="green">Paid</Tag>
              </Text>
              {/* <Text>
                Total Amount: <Tag color="red">{record.total_amount}</Tag>
              </Text> */}
              {/* <Text>
                Amount Paid:{" "}
                {record.amount_paid ? (
                  <Tag color="red">RM {record.amount_paid}</Tag>
                ) : (
                  "-"
                )}
              </Text> */}
              {/* <Text>
                Date Paid:{" "}
                <Tag color="#87d068">
                  {record.datetime_paid
                    ? formatDate(record.datetime_paid)
                    : "-"}
                </Tag>
              </Text> */}
            </Space>
          );
        } else if (Number(payment_status) === 0) {
          return (
            <>
              <Space direction="vertical" size="small">
                <Text>
                  Type: <Tag color="green">{record.payment_type}</Tag>
                </Text>
                <Text>
                  Max Term:{" "}
                  <Tag color={max_term_color}>{record.mc_max_term}</Tag>
                </Text>
                <Text>
                  Status: <Tag color="red">Pending</Tag>
                </Text>
              </Space>
            </>
          );
        } else if (Number(payment_status) === 2) {
          return (
            <>
              <Space direction="vertical" size="small">
                <Text>
                  Type: <Tag color="green">{record.payment_type}</Tag>
                </Text>
                <Text>
                  Max Term:{" "}
                  <Tag color={max_term_color}>{record.mc_max_term}</Tag>
                </Text>
                <Text>
                  Status: <Tag color="red">Unpaid</Tag>
                </Text>
              </Space>
            </>
          );
        } else {
          return (
            <>
              <Text>
                <Tag color="geekblue">No payment issued yet</Tag>
              </Text>
            </>
          );
        }
      },
      editable: true,
      filters: [
        { text: "Paid", value: 1 },
        { text: "Pending", value: 0 },
        { text: "Unpaid", value: 2 },
      ],
      onFilter: (value, record) => {
        if(
          (value == 0 && record.payment_status ==  null)
          || record.payment_status === value
        )
          return true;
        else
          return false;
      },
    },
    {
      title: "Payment Remark",
      dataIndex: "payment_remark",
      key: "payment_remark",
      editable: true,
      width: 180,
      ...getColumnSearchProps("payment_remark"), //IMPLEMENT SEARCH FILTER
    },
    {
      title: "Name In Full",
      dataIndex: "individual_name",
      key: "individual_name",
      editable: true,
      width: 200,
      ...getColumnSearchProps("individual_name"), //IMPLEMENT SEARCH FILTER
    },
    {
      title: "NRIC",
      dataIndex: "individual_nric",
      key: "individual_nric",
      editable: true,
      width: 180,
      ...getColumnSearchProps("individual_nric"), //IMPLEMENT SEARCH FILTER
    },
    {
      title: "Date Of Birth",
      dataIndex: "individual_dob",
      key: "individual_dob",
      editable: true,
      width: 150,
      ...getColumnSearchProps("individual_dob"), //IMPLEMENT SEARCH FILTER
    },
    {
      title: "Correspondence Address",
      dataIndex: "individual_correspondence_address",
      key: "individual_correspondence_address",
      editable: true,
      width: 200,
      ...getColumnSearchProps("individual_correspondence_address"), //IMPLEMENT SEARCH FILTER
    },
    {
      title: "Registered Address",
      dataIndex: "individual_registered_address",
      key: "individual_registered_address",
      editable: true,
      width: 200,
      ...getColumnSearchProps("individual_registered_address"), //IMPLEMENT SEARCH FILTER
    },
    {
      title: "Place Of Employment",
      dataIndex: "individual_place_of_employment",
      key: "individual_place_of_employment",
      editable: true,
      width: 200,
      ...getColumnSearchProps("individual_place_of_employment"), //IMPLEMENT SEARCH FILTER
    },
    {
      title: "Office Address",
      dataIndex: "individual_office_address",
      key: "individual_office_address",
      editable: true,
      width: 200,
      ...getColumnSearchProps("individual_office_address"), //IMPLEMENT SEARCH FILTER
    },
    {
      title: "Office Tel No",
      dataIndex: "individual_office_tel_no",
      key: "individual_office_tel_no",
      editable: true,
      ...getColumnSearchProps("individual_office_tel_no"), //IMPLEMENT SEARCH FILTER
    },
    {
      title: "Email",
      dataIndex: "individual_email",
      key: "individual_email",
      editable: true,
      width: 150,
      ...getColumnSearchProps("individual_email"), //IMPLEMENT SEARCH FILTER
    },
    {
      title: "Qualification",
      dataIndex: "individual_academic_qualification",
      key: "individual_academic_qualification",
      editable: true,
      width: 180,
      render: (data: any) => {
        const ctype =
          data === 0
            ? "None"
            : data === 1
            ? "Certificate"
            : data === 2
            ? "Diploma"
            : data === 3
            ? "Advanced Diploma"
            : data === 4
            ? "Bachelor"
            : data === 5
            ? "Masters"
            : data === 6
            ? "Doctoral"
            : "";
        return data && <Tag color="geekblue">{ctype}</Tag>;
      },
      filters: [
        { text: "None", value: 0 },
        { text: "Certificate", value: 1 },
        { text: "Diploma", value: 2 },
        { text: "Advanced Diploma", value: 3 },
        { text: "Bachelor", value: 4 },
        { text: "Masters", value: 5 },
        { text: "Doctoral", value: 6 },
      ],
      onFilter: (value, record) =>
        record.individual_academic_qualification === value,
    },
    {
      title: "H/P No",
      dataIndex: "individual_hp_no",
      key: "individual_hp_no",
      editable: true,
      width: 180,
      ...getColumnSearchProps("individual_hp_no"), //IMPLEMENT SEARCH FILTER
    },
    {
      title: "Designation",
      dataIndex: "individual_designation",
      key: "individual_designation",
      editable: true,
      width: 180,
      ...getColumnSearchProps("individual_designation"), //IMPLEMENT SEARCH FILTER
    },
    {
      title: "Nature of Work",
      dataIndex: "individual_nature_of_work",
      key: "individual_nature_of_work",
      editable: true,
      width: 180,
      ...getColumnSearchProps("individual_nature_of_work"), //IMPLEMENT SEARCH FILTER
    },
    {
      title: "No. Of Years With Present Employer",
      dataIndex: "individual_no_of_years_with_present_employer",
      key: "individual_no_of_years_with_present_employer",
      editable: true,
      width: 150,
      render: (data: any) => {
        if (data) {
          return <Tag color="geekblue">{data} Year(s)</Tag>;
        }
      },
    },
    {
      title: "Previous Employment Period (1)",
      dataIndex: "individual_previous_employment_period_1",
      key: "individual_previous_employment_period_1",
      editable: true,
      width: 150,
      render: (data: any) => {
        if (data) {
          return <Tag color="geekblue">{data} Year(s)</Tag>;
        }
      },
    },
    {
      title: "Previous Employment Designation (1)",
      dataIndex: "individual_previous_employment_designation_1",
      key: "individual_previous_employment_designation_1",
      editable: true,
      width: 150,
      render: (data: any) => {
        if (data) {
          return <Tag color="geekblue">{data} Year(s)</Tag>;
        }
      },
    },
    {
      title: "Previous Employment Period (2)",
      dataIndex: "individual_previous_employment_period_2",
      key: "individual_previous_employment_period_2",
      editable: true,
      width: 150,
      render: (data: any) => {
        if (data) {
          return <Tag color="geekblue">{data} Year(s)</Tag>;
        }
      },
    },
    {
      title: "Previous Employment Designation (2)",
      dataIndex: "individual_previous_employment_designation_2",
      key: "individual_previous_employment_designation_2",
      editable: true,
      width: 150,
      render: (data: any) => {
        if (data) {
          return <Tag color="geekblue">{data} Year(s)</Tag>;
        }
      },
    },
    {
      title: "Committee Type",
      dataIndex: "committee_typeID",
      key: "committee_typeID",
      editable: true,
      width: 180,
      render: (committee_typeID: any, record: DataType) => {
        return (
          <Tag color="geekblue">
            {record.committee_type_label ? record.committee_type_label : "None"}
          </Tag>
        );
      },
    },
  ];

  const onSelectChange = (
    newSelectedRowKeys: React.Key[],
    selectedRows: DataType[]
  ) => {
    console.log("selectedRowKeys changed: ", newSelectedRowKeys);
    setSelectedRowKeys(newSelectedRowKeys);

    // call api here
  };

  const rowSelection: TableRowSelection<DataType> = {
    selectedRowKeys,
    onChange: onSelectChange,
  };

  const [checkedColumns, setCheckedColumns] = useState([
    "operation",
    "memberID",
    "status",
    // "member_type_label",
    "individual_name",
    // "individual_nric",
    // "individual_nationality",
    // "individual_office_address",
    "individual_hp_no",
    "individual_email",
    "payment_status",
    // "committee_typeID",
  ]);

  const onChange = (checkedValues) => {
    setCheckedColumns(checkedValues);
    // console.log(checkedValues);
  };

  const [committeeTypeOptions, setCommitteeType] = useState([]);

  useEffect(() => {
    CorporateMemberController.getCommitteeType().then((response) => {
      const committeeTypeOptions = response.map((item) => ({
        label: item.label,
        value: item.committee_typeID,
      }));

      // Add a new row at the end of the array
      committeeTypeOptions.push({
        label: "None", // Customize as needed
        value: "null", // Provide the appropriate value
      });
      setCommitteeType(committeeTypeOptions);
    });
  }, []);

  const paymentStatusOptions = [
    { label: "Unpaid", value: 2 },
    { label: "Paid", value: 1 },
    { label: "Pending", value: 0 },
  ];
  const academicQualificationOptions = [
    { label: "None", value: 0 },
    { label: "Certificate", value: 1 },
    { label: "Diploma", value: 2 },
    { label: "Advanced Diploma", value: 3 },
    { label: "Bachelor", value: 4 },
    { label: "Masters", value: 5 },
    { label: "Doctoral", value: 6 },
  ];

  // Create mergedColumns directly using baseColumns
  const mergedColumns = baseColumns
    .filter(
      (col) =>
        typeof col.dataIndex === "string" &&
        checkedColumns.includes(col.dataIndex)
    )
    .map((col) => {
      if (!col.editable) {
        return col;
      }
      return {
        ...col,
        onCell: (record: DataType) => {
          const columnTitle =
            typeof col.title === "string" ? col.title : String(col.title);
          const columnDataIndex =
            typeof col.dataIndex === "string"
              ? col.dataIndex
              : String(col.dataIndex);
          return {
            record,
            inputType:
              columnDataIndex === "age"
                ? "number"
                : columnDataIndex === "individual_dob"
                ? "date"
                : columnDataIndex === "committee_typeID"
                ? "committee_typeID"
                : columnDataIndex === "payment_status"
                ? "select_payment"
                : columnDataIndex === "payment_remark"
                ? "payment_remark"
                : columnDataIndex === "individual_previous_employment_period_1"
                ? "individual_previous_employment_period_1"
                : columnDataIndex ===
                  "individual_previous_employment_designation_1"
                ? "individual_previous_employment_designation_1"
                : columnDataIndex === "individual_previous_employment_period_2"
                ? "individual_previous_employment_period_2"
                : columnDataIndex ===
                  "individual_previous_employment_designation_2"
                ? "individual_previous_employment_designation_2"
                : columnDataIndex === "individual_academic_qualification"
                ? "individual_academic_qualification"
                : columnDataIndex === "individual_nationality"
                ? "individual_nationality"
                : columnDataIndex === "individual_nric"
                ? "individual_nric"
                : "text", // Update to set 'date' for date columns
            dataIndex: columnDataIndex,
            title: columnTitle,
            editing: isEditing(record),
            options:
              col.dataIndex === "committee_typeID"
                ? committeeTypeOptions
                : col.dataIndex === "payment_status"
                ? paymentStatusOptions
                : col.dataIndex === "individual_academic_qualification"
                ? academicQualificationOptions
                : undefined,
          };
        },
      };
    });

  const { styles } = useStyle();

  return (
    <>
      <Box
        sx={{
          display: "flex",
          backgroundColor: "#e8e8e8",
          height: "100%", // scroll y for page
          minHeight: "150vh",
          width: "100vw", // Full viewport width
          overflow: "hidden", // Ensure no overflow from the Box itself
        }}
      >
        <Box
          component="main"
          sx={{
            flexGrow: 1,
            p: 3,
            display: "flex", // Ensures the table fills the remaining space
            flexDirection: "column",
            height: "100%", // Fill remaining height
            width: "100%", // Fill remaining width
          }}
        >
          <DrawerHeader />
          {/* <CustomSeparator pageName="membership" /> */}
          {contextHolder}
          <Typography
            gutterBottom
            variant="h4"
            sx={{ color: "text.secondary" }}
          >
            Affiliate Individual Membership Directory
          </Typography>
          <Stack spacing={2} direction="row" sx={{ mb: 3 }}>
            <CheckboxList
              baseColumns={baseColumns}
              checkedColumns={checkedColumns}
              onChange={onChange}
            />
            <AffiliateIndividualMembershipListExcel />

            {/** added by delon on 2025-07-30 */}
            {
              pendingRegistrationsCount["affiliate-individual"] > 0 ?
              <div className='notification-lbl'>
                <NotificationsIcon />
                There' {pendingRegistrationsCount["affiliate-individual"]  > 1 ? 're' : 's'} {pendingRegistrationsCount["affiliate-individual"]  + ' pending registration' + (pendingRegistrationsCount["affiliate-individual"]  > 1 ? 's': '')}
              </div>
              :
              null
            }
          </Stack>
          {/* Box to hold the table with full width/height */}
          <Box
            sx={{
              flexGrow: 1, // Ensures the table box expands
              backgroundColor: "#fff", // Set the background color for the table container
              height: "100%", // Ensures the table fills available height
              width: "100%", // Ensures the table fills available width
              overflow: "auto", // Allow scrolling if needed
              borderRadius: "8px", // Optional: for rounded corners
            }}
          >
            <Form form={form} component={false}>
              <Table<DataType>
                className={styles.customTable}
                components={{
                  body: { cell: EditableCell },
                }}
                bordered
                columns={mergedColumns}
                dataSource={rows}
                // rowSelection={rowSelection}
                rowKey="membership_registrationID" // Set your custom key here
                scroll={{ x: "max-content", y: 200 * 5 }}
              />
            </Form>
          </Box>
        </Box>
      </Box>

      <Modal
        title="Membership Number"
        open={isModalMemberIDOpen}
        onCancel={() => {
          setIsModalMemberIDOpen(false);
          form.resetFields();
        }}
        footer={[
          <Buttons
            key="cancel"
            onClick={() => {
              setIsModalMemberIDOpen(false);
              form.resetFields();
            }}
          >
            Cancel
          </Buttons>,
          <Buttons key="submit" type="primary" onClick={() => form.submit()}>
            Submit
          </Buttons>,
        ]}
      >
        <Form
          form={form}
          layout="vertical"
          onFinish={() => handleApprove(userID)}
        >
          <Form.Item
            label="Membership Number"
            name="membershipNumber"
            rules={[
              { required: true, message: "Membership number is required!" },
            ]}
          >
            <Input
              placeholder="Input membership number"
              onChange={(e) => setMembershipNumber(e.target.value)}
            />
          </Form.Item>

          <Form.Item
            label="Amount Paid"
            name="amountPaid"
            rules={[{ required: true, message: "Amount Paid is required!" }]}
          >
            <Input
              placeholder="Input amount paid"
              onChange={(e) => setPaymentAmount(e.target.value)}
            />
          </Form.Item>

          <Form.Item
            label="Reference"
            name="payment_reference"
            rules={[{ required: false }]}
          >
            <Input
              placeholder="Payment reference"
              onChange={(e) => setPaymentReference(e.target.value)}
            />
          </Form.Item>
        </Form>
      </Modal>

      <Modal
        title="Payment Amount"
        open={isModalPaymentOpen}
        onCancel={() => {
          setIsModalPaymentOpen(false);
          form.resetFields();
        }}
        footer={[
          <Buttons
            key="cancel"
            onClick={() => {
              setIsModalPaymentOpen(false);
              form.resetFields();
            }}
          >
            Cancel
          </Buttons>,
          <Buttons key="submit" type="primary" onClick={() => form.submit()}>
            Submit
          </Buttons>,
        ]}
      >
        <Form
          form={form}
          layout="vertical"
          onFinish={() => handleActivateMembership(userID)}
        >
          <Form.Item
            label="Amount Paid"
            name="amountPaid"
            rules={[{ required: true, message: "Amount Paid is required!" }]}
          >
            <Input
              placeholder="Input amount paid"
              onChange={(e) => setPaymentAmount(e.target.value)}
            />
          </Form.Item>

          <Form.Item
            label="Reference"
            name="payment_reference"
            rules={[{ required: false }]}
          >
            <Input
              placeholder="Payment reference"
              onChange={(e) => setPaymentReference(e.target.value)}
            />
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
}

export default App;
